export const messagesSupport = {
    pt: {
        message: {
            doubtsPopup: 'Dúvidas ou problemas?',
            sendSupportEmail: 'Envie um e-mail para o nosso suporte em:',
            supportEmailHelp: 'e conte com a gente para te ajudar!',
            copyError: 'Não foi possível copiar o e-mail'
        }
    },
    es: {
        message: {
            doubtsPopup: '¿Preguntas o problemas?',
            sendSupportEmail: 'Envíe un correo electrónico a nuestro soporte en:',
            supportEmailHelp: '¡Y cuenta con nosotros para ayudarte!',
            copyError: 'No se pudo copiar el correo electrónico'
        }
    },
    en: {
        message: {
            doubtsPopup: 'Questions or problems?',
            sendSupportEmail: 'Send an email to our support at:',
            supportEmailHelp: 'and count on us to help you!',
            copyError: 'Unable to copy the email'
        }
    }
}
